export default __webpack_public_path__ + "static/SubpageBanners_Adopt-A-Shark-6f51540b685b306c2d80a873ffa67f33.jpg";